import * as React from "react";

import { SvgIcon } from "./SvgIcon";

export const HeartIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = "text-white",
  strokeWidth = 1.2,
  fillColor = "#FF0033",
  classes
}) => (
  <svg
    data-cy="heart-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 9"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M4.50048 8.14592L0.969948 4.6048L0.969978 4.60477L0.966668 4.60157C0.641372 4.2871 0.395949 3.78759 0.29714 3.24261C0.19846 2.69833 0.251927 2.14204 0.482759 1.71341C0.603657 1.49323 1.05611 0.971872 1.71805 0.803679C2.34672 0.643938 3.24212 0.78521 4.31075 2.02284L4.50465 2.24741L4.69308 2.01823C5.20294 1.39811 5.68161 1.05677 6.10646 0.888917C6.52868 0.722106 6.91125 0.721143 7.24286 0.803933C7.57785 0.887566 7.86715 1.05855 8.09118 1.24232C8.3174 1.42789 8.46278 1.61462 8.51722 1.71348C8.74804 2.14239 8.80147 2.69867 8.70292 3.24284C8.60423 3.78779 8.35904 4.28721 8.03417 4.60169L8.03414 4.60166L8.03101 4.6048L4.50048 8.14592Z"
      stroke="#919699"
    />
  </svg>
);

export const MicrosoftIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = "text-white",
  // strokeWidth = 1.2,
  fillColor = "#FF0033",
  classes
}) => (
  <svg
    data-cy="microsoft-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 2499.6 2500"
    viewBox="0 0 2499.6 2500"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path d="m1187.9 1187.9h-1187.9v-1187.9h1187.9z" fill="#f1511b" />
    <path d="m2499.6 1187.9h-1188v-1187.9h1187.9v1187.9z" fill="#80cc28" />
    <path d="m1187.9 2500h-1187.9v-1187.9h1187.9z" fill="#00adef" />
    <path d="m2499.6 2500h-1188v-1187.9h1187.9v1187.9z" fill="#fbbc09" />
  </svg>
);

export const GoogleIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-white",
  // strokeWidth = 1.2,
  // fillColor = "#FF0033",
  classes
}) => (
  <svg
    data-cy="google-icon"
    width={width}
    height={height}
    // fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M27.9851 14.2618C27.9851 13.1146 27.8899 12.2775 27.6837 11.4094H14.2788V16.5871H22.1472C21.9886 17.8738 21.132 19.8116 19.2283 21.1137L19.2016 21.287L23.44 24.4956L23.7336 24.5242C26.4304 22.0904 27.9851 18.5093 27.9851 14.2618Z"
      fill="#4285F4"
    />
    <path
      d="M14.279 27.904C18.1338 27.904 21.37 26.6637 23.7338 24.5245L19.2285 21.114C18.0228 21.9356 16.4047 22.5092 14.279 22.5092C10.5034 22.5092 7.29894 20.0754 6.15663 16.7114L5.9892 16.7253L1.58205 20.0583L1.52441 20.2149C3.87224 24.7725 8.69486 27.904 14.279 27.904Z"
      fill="#34A853"
    />
    <path
      d="M6.15656 16.7113C5.85516 15.8432 5.68072 14.913 5.68072 13.9519C5.68072 12.9907 5.85516 12.0606 6.14071 11.1925L6.13272 11.0076L1.67035 7.62109L1.52435 7.68896C0.556704 9.58024 0.00146484 11.7041 0.00146484 13.9519C0.00146484 16.1997 0.556704 18.3234 1.52435 20.2147L6.15656 16.7113Z"
      fill="#FBBC05"
    />
    <path
      d="M14.279 5.3947C16.9599 5.3947 18.7683 6.52635 19.7995 7.47204L23.8289 3.6275C21.3542 1.37969 18.1338 0 14.279 0C8.69485 0 3.87223 3.1314 1.52441 7.68899L6.14077 11.1925C7.29893 7.82856 10.5034 5.3947 14.279 5.3947Z"
      fill="#EB4335"
    />
  </svg>
);

export const GoogleMonoIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 20"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M19 9.91406C19 15.4414 15.2273 19.375 9.65574 19.375C4.31393 19.375 0 15.0469 0 9.6875C0 4.32812 4.31393 0 9.65574 0C12.2566 0 14.4447 0.957031 16.1305 2.53516L13.5025 5.07031C10.0645 1.74219 3.67152 4.24219 3.67152 9.6875C3.67152 13.0664 6.36189 15.8047 9.65574 15.8047C13.4791 15.8047 14.9119 13.0547 15.1377 11.6289H9.65574V8.29688H18.8482C18.9377 8.79297 19 9.26953 19 9.91406Z" />
  </svg>
);

export const FacebookIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 20"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M2.71512 11.6914V20H7.48714V11.6914H11.0456L11.7861 7.87109H7.48714V6.51953C7.48714 4.5 8.32225 3.72656 10.4779 3.72656C11.1484 3.72656 11.6874 3.74219 12 3.77344V0.308594C11.4117 0.15625 9.97189 0 9.1409 0C4.74323 0 2.71512 1.97266 2.71512 6.22656V7.87109H0V11.6914H2.71512Z" />
  </svg>
);

export const DownloadIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = "text-white",
  strokeWidth = 1.2,
  fillColor = "#666666",
  classes
}) => (
  <svg
    data-cy="download-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M10.125 1.125C10.125 0.502734 9.62227 0 9 0C8.37773 0 7.875 0.502734 7.875 1.125V9.65742L5.29453 7.07695C4.85508 6.6375 4.14141 6.6375 3.70195 7.07695C3.2625 7.51641 3.2625 8.23008 3.70195 8.66953L8.20195 13.1695C8.64141 13.609 9.35508 13.609 9.79453 13.1695L14.2945 8.66953C14.734 8.23008 14.734 7.51641 14.2945 7.07695C13.8551 6.6375 13.1414 6.6375 12.702 7.07695L10.125 9.65742V1.125ZM2.25 12.375C1.00898 12.375 0 13.384 0 14.625V15.75C0 16.991 1.00898 18 2.25 18H15.75C16.991 18 18 16.991 18 15.75V14.625C18 13.384 16.991 12.375 15.75 12.375H12.1816L10.5891 13.9676C9.71016 14.8465 8.28633 14.8465 7.40742 13.9676L5.81836 12.375H2.25ZM15.1875 14.3438C15.4113 14.3438 15.6259 14.4326 15.7841 14.5909C15.9424 14.7491 16.0312 14.9637 16.0312 15.1875C16.0312 15.4113 15.9424 15.6259 15.7841 15.7841C15.6259 15.9424 15.4113 16.0312 15.1875 16.0312C14.9637 16.0312 14.7491 15.9424 14.5909 15.7841C14.4326 15.6259 14.3438 15.4113 14.3438 15.1875C14.3438 14.9637 14.4326 14.7491 14.5909 14.5909C14.7491 14.4326 14.9637 14.3438 15.1875 14.3438Z"
    />
  </svg>
);

export const QuestionIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = "text-white",
  strokeWidth = 1.2,
  fillColor = "#FF0033",
  classes
}) => (
  <svg
    data-cy="question-mark-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M14.1798 13.9175L14.1802 13.9168C14.3152 13.6701 14.659 13.262 15.577 12.5591C16.4325 11.8915 16.8539 11.3221 17.1628 10.8421C17.4879 10.3257 17.6351 9.82835 17.6361 9.31021C17.636 8.18268 17.1514 7.20609 16.3316 6.6076C15.3851 5.9176 14.3671 5.59399 13.0945 5.59399C11.9704 5.59399 10.8793 5.96283 9.84443 6.71407L9.84417 6.71426C9.10179 7.25244 8.60048 8.05468 8.37366 9.14341L8.37362 9.14357L8.29548 9.51803L10.02 9.70473L10.0963 9.41671C10.2733 8.74654 10.6497 8.16736 11.1888 7.74827C11.7178 7.33472 12.3712 7.14073 13.1011 7.14073C13.8929 7.14073 14.5928 7.32082 15.1242 7.73662L14.1798 13.9175ZM14.1798 13.9175C14.0995 14.0647 14.0184 14.2891 13.9593 14.639C13.9377 14.7656 13.922 14.8979 13.9092 15.0329L13.9091 15.0335M14.1798 13.9175L13.9091 15.0335M13.9091 15.0335L13.8798 15.3477L12.0973 15.352L12.1117 14.9898L12.1117 14.9894M13.9091 15.0335L12.1117 14.9894M12.1117 14.9894C12.1159 14.883 12.1272 14.6825 12.1541 14.5019L12.1544 14.5002M12.1117 14.9894L12.1544 14.5002M12.1544 14.5002C12.2358 13.94 12.4247 13.4564 12.7071 13.0548L12.7073 13.0546M12.1544 14.5002L12.7073 13.0546M12.7073 13.0546C12.972 12.6777 13.5226 12.1553 14.4506 11.4489L14.4511 11.4485M12.7073 13.0546L14.4511 11.4485M14.4511 11.4485C15.1531 10.9128 15.4764 10.5707 15.6284 10.3404L15.6298 10.3381M14.4511 11.4485L15.6298 10.3381M15.6298 10.3381C15.8137 10.0562 15.9073 9.7488 15.9073 9.41428M15.6298 10.3381L15.9073 9.41428M15.9073 9.41428C15.9073 8.7328 15.6509 8.14813 15.1243 7.73666L15.9073 9.41428ZM12.9997 19.9116C12.3315 19.9116 11.7879 19.3676 11.7879 18.701C11.7879 18.0317 12.3319 17.4881 12.9997 17.4881C13.6672 17.4881 14.2115 18.0326 14.2115 18.701C14.2115 19.3676 13.6679 19.9116 12.9997 19.9116Z"
      fill="#919699"
      stroke="#919699"
    />
    <path
      strokeWidth={strokeWidth}
      d="M13 0.8C6.27301 0.8 0.8 6.27301 0.8 13C0.8 19.727 6.27301 25.2 13 25.2C19.727 25.2 25.2 19.727 25.2 13C25.2 6.27301 19.727 0.8 13 0.8ZM13 23.876C7.00326 23.876 2.124 18.9967 2.124 13C2.124 7.00326 7.00326 2.124 13 2.124C18.9967 2.124 23.876 7.00326 23.876 13C23.876 18.9967 18.9967 23.876 13 23.876Z"
      fill="#919699"
      stroke="#919699"
    />
  </svg>
);

export const ChevronRightIcon: SvgIcon = ({
  width = 5,
  height = 8,
  strokeColor = "text-white",
  strokeWidth = 1.2,
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    onClick={onClick}
    data-cy="chevronRight-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5 8"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M0.75 0.75L4.25 4L0.75 7.25"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TriangleWarningIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "#FF685F",
  strokeWidth = 0,
  fillColor = "#000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.84051 4.64506C9.49487 3.95504 8.51014 3.95486 8.16424 4.64475L4.21698 12.5175C3.90441 13.1409 4.35766 13.8752 5.05504 13.8752H12.9459C13.6432 13.8752 14.0964 13.1412 13.7842 12.5178L9.84051 4.64506ZM7.15856 4.14053C7.91954 2.62277 10.086 2.62316 10.8464 4.1412L14.79 12.014C15.477 13.3854 14.4798 15.0002 12.9459 15.0002H5.05504C3.52082 15.0002 2.52366 13.3848 3.2113 12.0133L7.15856 4.14053Z"
      fill={strokeColor}
    />
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6.75C9.41421 6.75 9.75 7.08579 9.75 7.5V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V7.5C8.25 7.08579 8.58579 6.75 9 6.75Z"
      fill={strokeColor}
    />
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12Z"
      fill={strokeColor}
    />
  </svg>
);

export const ToastCheckIcon: SvgIcon = ({
  width = 28,
  height = 28,
  strokeColor = "#00D37E",
  fillColor = "#00D37E",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`fill-current text-white ${strokeColor} ${classes}`}
  >
    <g fillRule="evenodd">
      <circle fill={strokeColor} cx="12" cy="12" r="10" />
      <path
        d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z"
        fill="inherit"
      />
    </g>
  </svg>
);

export const ToastCloseIcon: SvgIcon = ({
  width = 28,
  height = 28,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`fill-current text-white ${strokeColor} ${classes}`}
  >
    <g fillRule="evenodd">
      <path
        d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z"
        fill="#E2423E"
      />
      <path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit" />
    </g>
  </svg>
);

export const ToastWarningIcon: SvgIcon = ({
  width = 24,
  height = 25,
  strokeColor = "text-white",
  strokeWidth = 1.5,
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 25"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M4.75 12.5C4.75 8.49594 7.99594 5.25 12 5.25C16.0041 5.25 19.25 8.49594 19.25 12.5C19.25 16.5041 16.0041 19.75 12 19.75C7.99594 19.75 4.75 16.5041 4.75 12.5Z"
      stroke="#F7C839"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M15.25 12.5L8.75 12.5"
      stroke="#F7C839"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FileIcon: SvgIcon = ({
  width = 64,
  height = 81,
  strokeColor = "text-white",
  fillColor = "transparent",
  classes
}) => (
  <svg
    data-cy="account-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 81"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M18.7143 40.5H45.2857M18.7143 58.0556H45.2857M54.1429 80H9.85714C7.50808 80 5.25523 79.0752 3.5942 77.429C1.93316 75.7829 1 73.5502 1 71.2222V9.77778C1 7.44977 1.93316 5.2171 3.5942 3.57095C5.25523 1.9248 7.50808 1 9.85714 1H34.5951C35.7696 1.00025 36.8958 1.46281 37.7261 2.28594L61.7024 26.0474C62.533 26.8703 62.9997 27.9864 63 29.1503V71.2222C63 73.5502 62.0668 75.7829 60.4058 77.429C58.7448 79.0752 56.4919 80 54.1429 80Z"
      stroke="#2F80ED"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIcon: SvgIcon = ({ width = 20, height = 20, strokeColor = "text-white", fillColor = "", classes }) => (
  <svg
    data-cy="account-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M9.04897 2.92708C9.34897 2.00608 10.652 2.00608 10.951 2.92708L12.021 6.21908C12.0863 6.41957 12.2134 6.59426 12.384 6.71818C12.5547 6.84211 12.7601 6.90892 12.971 6.90908H16.433C17.402 6.90908 17.804 8.14908 17.021 8.71908L14.221 10.7531C14.05 10.8771 13.9227 11.0521 13.8573 11.2529C13.7919 11.4538 13.7918 11.6702 13.857 11.8711L14.927 15.1631C15.227 16.0841 14.172 16.8511 13.387 16.2811L10.587 14.2471C10.4162 14.1231 10.2105 14.0563 9.99947 14.0563C9.78842 14.0563 9.58277 14.1231 9.41197 14.2471L6.61197 16.2811C5.82797 16.8511 4.77397 16.0841 5.07297 15.1631L6.14297 11.8711C6.20815 11.6702 6.20803 11.4538 6.14264 11.2529C6.07725 11.0521 5.94994 10.8771 5.77897 10.7531L2.97997 8.72008C2.19697 8.15008 2.59997 6.91008 3.56797 6.91008H7.02897C7.24002 6.91013 7.44568 6.84342 7.6165 6.71948C7.78732 6.59554 7.91455 6.42073 7.97997 6.22008L9.04997 2.92808L9.04897 2.92708Z"
      fill="#2F80ED"
    />
  </svg>
);
export const EmployeeIcon: SvgIcon = ({
  width = 39,
  height = 39,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="sm-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 39 39"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 17.5501C21.0515 17.5501 22.5395 16.9338 23.6366 15.8367C24.7336 14.7396 25.35 13.2516 25.35 11.7001C25.35 10.1486 24.7336 8.66061 23.6366 7.56352C22.5395 6.46644 21.0515 5.8501 19.5 5.8501C17.9485 5.8501 16.4605 6.46644 15.3634 7.56352C14.2663 8.66061 13.65 10.1486 13.65 11.7001C13.65 13.2516 14.2663 14.7396 15.3634 15.8367C16.4605 16.9338 17.9485 17.5501 19.5 17.5501ZM5.84998 35.1001C5.84998 33.3076 6.20304 31.5326 6.88902 29.8765C7.575 28.2204 8.58045 26.7156 9.84797 25.4481C11.1155 24.1806 12.6203 23.1751 14.2763 22.4891C15.9324 21.8032 17.7074 21.4501 19.5 21.4501C21.2925 21.4501 23.0675 21.8032 24.7236 22.4891C26.3797 23.1751 27.8845 24.1806 29.152 25.4481C30.4195 26.7156 31.425 28.2204 32.1109 29.8765C32.7969 31.5326 33.15 33.3076 33.15 35.1001H5.84998Z"
    />
  </svg>
);

export const DollarIcon: SvgIcon = ({
  width = 46,
  height = 46,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="sm-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46 46"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M19.3963 17.0614C19.7528 16.8245 20.1921 16.6106 20.7004 16.4473V20.3527C20.2398 20.2083 19.801 20.0017 19.3963 19.7386C18.5614 19.182 18.4004 18.6622 18.4004 18.4C18.4004 18.1378 18.5614 17.618 19.3963 17.0614ZM25.3004 29.5527V25.6473C25.8064 25.8106 26.248 26.0245 26.6045 26.2614C27.4417 26.8203 27.6004 27.3378 27.6004 27.6C27.6004 27.8622 27.4394 28.382 26.6045 28.9386C26.1998 29.2017 25.761 29.4083 25.3004 29.5527Z"
      fill="#27AE60"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9996 41.4C27.8796 41.4 32.5597 39.4614 36.0104 36.0108C39.461 32.5601 41.3996 27.88 41.3996 23C41.3996 18.12 39.461 13.4399 36.0104 9.98924C32.5597 6.53857 27.8796 4.60001 22.9996 4.60001C18.1196 4.60001 13.4395 6.53857 9.98884 9.98924C6.53818 13.4399 4.59961 18.12 4.59961 23C4.59961 27.88 6.53818 32.5601 9.98884 36.0108C13.4395 39.4614 18.1196 41.4 22.9996 41.4ZM25.2996 11.5C25.2996 10.89 25.0573 10.305 24.626 9.87366C24.1946 9.44233 23.6096 9.20001 22.9996 9.20001C22.3896 9.20001 21.8046 9.44233 21.3733 9.87366C20.9419 10.305 20.6996 10.89 20.6996 11.5V11.7116C19.3258 11.9562 18.015 12.4739 16.8448 13.2342C15.1842 14.3382 13.7996 16.1207 13.7996 18.4C13.7996 20.677 15.1842 22.4595 16.8448 23.5658C17.9488 24.3018 19.269 24.8193 20.6996 25.0884V29.5527C19.8003 29.2606 19.1356 28.8236 18.7607 28.3935C18.5661 28.1547 18.3256 27.9575 18.0533 27.8134C17.7811 27.6694 17.4827 27.5815 17.1758 27.555C16.8689 27.5285 16.5599 27.5639 16.2669 27.659C15.974 27.7542 15.7032 27.9073 15.4705 28.1091C15.2379 28.311 15.0481 28.5575 14.9126 28.834C14.777 29.1106 14.6983 29.4116 14.6813 29.7191C14.6642 30.0267 14.7091 30.3345 14.8133 30.6243C14.9175 30.9142 15.0788 31.1802 15.2877 31.4065C16.5803 32.8992 18.5376 33.8813 20.6996 34.2884V34.5C20.6996 35.11 20.9419 35.695 21.3733 36.1264C21.8046 36.5577 22.3896 36.8 22.9996 36.8C23.6096 36.8 24.1946 36.5577 24.626 36.1264C25.0573 35.695 25.2996 35.11 25.2996 34.5V34.2884C26.6735 34.0438 27.9843 33.5261 29.1544 32.7658C30.815 31.6618 32.1996 29.8793 32.1996 27.6C32.1996 25.323 30.815 23.5405 29.1544 22.4342C27.9843 21.6739 26.6735 21.1562 25.2996 20.9116V16.4473C26.1989 16.7394 26.8636 17.1764 27.2385 17.6065C27.4349 17.8395 27.6756 18.0312 27.9467 18.1704C28.2178 18.3095 28.5139 18.3935 28.8177 18.4172C29.1215 18.441 29.427 18.4042 29.7165 18.3089C30.0059 18.2136 30.2736 18.0617 30.5038 17.8621C30.7341 17.6625 30.9224 17.4191 31.0578 17.146C31.1931 16.873 31.2729 16.5758 31.2925 16.2717C31.312 15.9676 31.2709 15.6626 31.1716 15.3745C31.0722 15.0864 30.9166 14.821 30.7138 14.5935C29.4189 13.1008 27.4639 12.1187 25.2996 11.7116V11.5Z"
      fill="#27AE60"
      fillOpacity="0.5"
    />
  </svg>
);

export const ProtectionIcon: SvgIcon = ({
  width = 46,
  height = 46,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="sm-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46 46"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.98141 11.4977C11.6402 11.4149 18.0427 8.91816 22.9996 4.4712C27.9562 8.91899 34.3587 11.4166 41.0178 11.5C41.2708 12.995 41.3996 14.536 41.3996 16.1023C41.3996 28.1198 33.7176 38.3433 22.9996 42.1314C12.2816 38.341 4.59961 28.1175 4.59961 16.1C4.59961 14.5314 4.73071 12.995 4.98141 11.4977ZM31.5257 20.0261C31.9447 19.5923 32.1765 19.0113 32.1713 18.4083C32.166 17.8052 31.9241 17.2284 31.4977 16.8019C31.0713 16.3755 30.4944 16.1336 29.8913 16.1283C29.2883 16.1231 28.7073 16.3549 28.2735 16.7739L20.6996 24.3478L17.7257 21.3739C17.2919 20.9549 16.7109 20.7231 16.1079 20.7283C15.5048 20.7336 14.928 20.9755 14.5015 21.4019C14.0751 21.8284 13.8332 22.4052 13.828 23.0083C13.8227 23.6113 14.0545 24.1923 14.4735 24.6261L19.0735 29.2261C19.5048 29.6573 20.0897 29.8995 20.6996 29.8995C21.3095 29.8995 21.8944 29.6573 22.3257 29.2261L31.5257 20.0261Z"
      fill="#2F80ED"
      fillOpacity="0.5"
    />
    <rect x="11" y="14" width="24" height="18" fill="#97BFF6" />
  </svg>
);
export const DismissalIcon: SvgIcon = ({
  width = 46,
  height = 46,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="sm-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46 46"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.9967 34.247C28.3387 36.1363 25.0975 37.0233 21.8479 36.7507C18.5982 36.478 15.5501 35.0634 13.2441 32.7576C10.938 30.4519 9.52306 27.4039 9.25004 24.1543C8.97702 20.9047 9.86362 17.6634 11.7526 15.0052L30.9967 34.2516V34.247ZM34.2489 30.9948L15.0048 11.753C17.6629 9.86243 20.9048 8.97453 24.1553 9.24685C27.4058 9.51917 30.4548 10.9341 32.7613 13.2406C35.0678 15.5471 36.4827 18.5961 36.7551 21.8466C37.0274 25.0971 36.1395 28.339 34.2489 30.9971V30.9948ZM41.3996 23C41.3996 27.88 39.461 32.5601 36.0104 36.0108C32.5597 39.4614 27.8796 41.4 22.9996 41.4C18.1196 41.4 13.4395 39.4614 9.98884 36.0108C6.53818 32.5601 4.59961 27.88 4.59961 23C4.59961 18.12 6.53818 13.4399 9.98884 9.98924C13.4395 6.53857 18.1196 4.60001 22.9996 4.60001C27.8796 4.60001 32.5597 6.53857 36.0104 9.98924C39.461 13.4399 41.3996 18.12 41.3996 23V23Z"
      fill="#EB5757"
      fillOpacity="0.5"
    />
  </svg>
);
export const RiskIcon: SvgIcon = ({
  width = 46,
  height = 46,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="sm-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46 46"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8625 8.44253C20.6784 5.18582 25.3239 5.18582 27.1375 8.44253L40.3831 32.1973C42.1635 35.3918 39.8775 39.3333 36.248 39.3333H9.75433C6.12245 39.3333 3.83651 35.3918 5.61684 32.1973L18.8625 8.44253ZM25.3738 32.1518C25.3738 32.7869 25.1237 33.396 24.6785 33.8451C24.2333 34.2942 23.6295 34.5465 23 34.5465C22.3704 34.5465 21.7666 34.2942 21.3215 33.8451C20.8763 33.396 20.6262 32.7869 20.6262 32.1518C20.6262 31.5167 20.8763 30.9076 21.3215 30.4586C21.7666 30.0095 22.3704 29.7572 23 29.7572C23.6295 29.7572 24.2333 30.0095 24.6785 30.4586C25.1237 30.9076 25.3738 31.5167 25.3738 32.1518ZM23 12.9947C22.3704 12.9947 21.7666 13.247 21.3215 13.6961C20.8763 14.1452 20.6262 14.7543 20.6262 15.3894V22.5733C20.6262 23.2084 20.8763 23.8175 21.3215 24.2665C21.7666 24.7156 22.3704 24.9679 23 24.9679C23.6295 24.9679 24.2333 24.7156 24.6785 24.2665C25.1237 23.8175 25.3738 23.2084 25.3738 22.5733V15.3894C25.3738 14.7543 25.1237 14.1452 24.6785 13.6961C24.2333 13.247 23.6295 12.9947 23 12.9947Z"
      fill="#EB5757"
      fillOpacity="0.5"
    />
  </svg>
);

export const CheckIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="check-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM11.707 6.707C11.8892 6.5184 11.99 6.2658 11.9877 6.0036C11.9854 5.7414 11.8802 5.49059 11.6948 5.30518C11.5094 5.11977 11.2586 5.0146 10.9964 5.01233C10.7342 5.01005 10.4816 5.11084 10.293 5.293L7 8.586L5.707 7.293C5.5184 7.11084 5.2658 7.01005 5.0036 7.01233C4.7414 7.0146 4.49059 7.11977 4.30518 7.30518C4.11977 7.49059 4.0146 7.7414 4.01233 8.0036C4.01005 8.2658 4.11084 8.5184 4.293 8.707L6.293 10.707C6.48053 10.8945 6.73484 10.9998 7 10.9998C7.26516 10.9998 7.51947 10.8945 7.707 10.707L11.707 6.707Z"
    />
  </svg>
);

export const CompanyIcon: SvgIcon = ({
  width = 53,
  height = 60,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="company-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 53 60"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 7.5C3.75 5.51088 4.54018 3.60322 5.9467 2.1967C7.35322 0.790176 9.26088 0 11.25 0H41.25C43.2391 0 45.1468 0.790176 46.5533 2.1967C47.9598 3.60322 48.75 5.51088 48.75 7.5V52.5C49.7446 52.5 50.6984 52.8951 51.4017 53.5983C52.1049 54.3016 52.5 55.2554 52.5 56.25C52.5 57.2446 52.1049 58.1984 51.4017 58.9017C50.6984 59.6049 49.7446 60 48.75 60H37.5C36.5054 60 35.5516 59.6049 34.8484 58.9017C34.1451 58.1984 33.75 57.2446 33.75 56.25V48.75C33.75 47.7554 33.3549 46.8016 32.6516 46.0984C31.9484 45.3951 30.9946 45 30 45H22.5C21.5054 45 20.5516 45.3951 19.8484 46.0984C19.1451 46.8016 18.75 47.7554 18.75 48.75V56.25C18.75 57.2446 18.3549 58.1984 17.6516 58.9017C16.9484 59.6049 15.9946 60 15 60H3.75C2.75544 60 1.80161 59.6049 1.09835 58.9017C0.395088 58.1984 0 57.2446 0 56.25C0 55.2554 0.395088 54.3016 1.09835 53.5983C1.80161 52.8951 2.75544 52.5 3.75 52.5V7.5ZM15 11.25H22.5V18.75H15V11.25ZM22.5 26.25H15V33.75H22.5V26.25ZM30 11.25H37.5V18.75H30V11.25ZM37.5 26.25H30V33.75H37.5V26.25Z"
      fill="#2F80ED"
    />
  </svg>
);

export const GuidesIcon: SvgIcon = ({
  width = 85,
  height = 62,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="guides-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 85 62"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      d="M37.1184 4.37844C31.337 1.48761 24.9894 -0.00988294 18.5592 4.90838e-05C11.9044 4.90838e-05 5.60488 1.57932 0 4.37844V58.836C5.78145 55.9454 12.129 54.4479 18.5592 54.4576C27.4093 54.4576 35.6231 57.235 42.4211 62C49.4527 57.0729 57.7705 54.4438 66.2829 54.4576C72.9377 54.4576 79.2372 56.0369 84.8421 58.836V4.37844C79.0607 1.48761 72.7131 -0.00988294 66.2829 4.90838e-05C59.6281 4.90838e-05 53.3286 1.57932 47.7237 4.37844V43.5661C47.7237 45.0104 47.165 46.3956 46.1706 47.4168C45.1761 48.4381 43.8274 49.0119 42.4211 49.0119C41.0147 49.0119 39.666 48.4381 38.6715 47.4168C37.6771 46.3956 37.1184 45.0104 37.1184 43.5661V4.37844Z"
      fill="#2F80ED"
    />
  </svg>
);

export const DocumentsIcon: SvgIcon = ({
  width = 47,
  height = 62,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="guides-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47 62"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.75C0 5.69457 0.816515 3.72333 2.26992 2.26992C3.72333 0.816515 5.69457 0 7.75 0H25.5208C27.576 0.00043894 29.5469 0.817242 31 2.27075L44.2292 15.5C45.6828 16.9531 46.4996 18.924 46.5 20.9792V54.25C46.5 56.3054 45.6835 58.2767 44.2301 59.7301C42.7767 61.1835 40.8054 62 38.75 62H7.75C5.69457 62 3.72333 61.1835 2.26992 59.7301C0.816515 58.2767 0 56.3054 0 54.25V7.75ZM7.75 31C7.75 29.9723 8.15826 28.9867 8.88496 28.26C9.61167 27.5333 10.5973 27.125 11.625 27.125H34.875C35.9027 27.125 36.8883 27.5333 37.615 28.26C38.3417 28.9867 38.75 29.9723 38.75 31C38.75 32.0277 38.3417 33.0133 37.615 33.74C36.8883 34.4667 35.9027 34.875 34.875 34.875H11.625C10.5973 34.875 9.61167 34.4667 8.88496 33.74C8.15826 33.0133 7.75 32.0277 7.75 31ZM11.625 42.625C10.5973 42.625 9.61167 43.0333 8.88496 43.76C8.15826 44.4867 7.75 45.4723 7.75 46.5C7.75 47.5277 8.15826 48.5133 8.88496 49.24C9.61167 49.9667 10.5973 50.375 11.625 50.375H34.875C35.9027 50.375 36.8883 49.9667 37.615 49.24C38.3417 48.5133 38.75 47.5277 38.75 46.5C38.75 45.4723 38.3417 44.4867 37.615 43.76C36.8883 43.0333 35.9027 42.625 34.875 42.625H11.625Z"
      // fill="#2F80ED"
    />
  </svg>
);

export const SyncIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="guides-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      d="M7.99979 4.99959C7.73457 4.99959 7.48022 5.10495 7.29268 5.29249C7.10514 5.48002 6.99979 5.73438 6.99979 5.99959C6.99979 6.26481 7.10514 6.51916 7.29268 6.7067C7.48022 6.89424 7.73457 6.99959 7.99979 6.99959H13.5858L12.2928 8.29259C12.1106 8.48119 12.0098 8.7338 12.0121 8.99599C12.0144 9.25819 12.1196 9.509 12.305 9.69441C12.4904 9.87982 12.7412 9.98499 13.0034 9.98727C13.2656 9.98954 13.5182 9.88875 13.7068 9.70659L16.7068 6.70659C16.8943 6.51906 16.9996 6.26476 16.9996 5.99959C16.9996 5.73443 16.8943 5.48012 16.7068 5.29259L13.7068 2.29259C13.6145 2.19708 13.5042 2.1209 13.3822 2.06849C13.2602 2.01608 13.129 1.9885 12.9962 1.98734C12.8634 1.98619 12.7317 2.01149 12.6088 2.06177C12.4859 2.11205 12.3743 2.18631 12.2804 2.2802C12.1865 2.37409 12.1122 2.48574 12.062 2.60864C12.0117 2.73154 11.9864 2.86321 11.9875 2.99599C11.9887 3.12877 12.0163 3.25999 12.0687 3.382C12.1211 3.504 12.1973 3.61435 12.2928 3.70659L13.5858 4.99959H7.99979ZM11.9998 14.9996C12.265 14.9996 12.5194 14.8942 12.7069 14.7067C12.8944 14.5192 12.9998 14.2648 12.9998 13.9996C12.9998 13.7344 12.8944 13.48 12.7069 13.2925C12.5194 13.1049 12.265 12.9996 11.9998 12.9996H6.41379L7.70679 11.7066C7.8023 11.6143 7.87848 11.504 7.93089 11.382C7.9833 11.26 8.01088 11.1288 8.01204 10.996C8.01319 10.8632 7.98789 10.7315 7.93761 10.6086C7.88733 10.4857 7.81307 10.3741 7.71918 10.2802C7.62529 10.1863 7.51364 10.1121 7.39074 10.0618C7.26784 10.0115 7.13616 9.98619 7.00339 9.98734C6.87061 9.9885 6.73939 10.0161 6.61738 10.0685C6.49538 10.1209 6.38503 10.1971 6.29279 10.2926L3.29279 13.2926C3.10532 13.4801 3 13.7344 3 13.9996C3 14.2648 3.10532 14.5191 3.29279 14.7066L6.29279 17.7066C6.48139 17.8888 6.73399 17.9895 6.99619 17.9873C7.25838 17.985 7.5092 17.8798 7.6946 17.6944C7.88001 17.509 7.98518 17.2582 7.98746 16.996C7.98974 16.7338 7.88894 16.4812 7.70679 16.2926L6.41379 14.9996H11.9998Z"
      fill="white"
    />
  </svg>
);

export const SearchIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = "text-white",
  strokeWidth = 1.2,
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="search-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M11 4.75C7.54822 4.75 4.75 7.54822 4.75 11C4.75 14.4518 7.54822 17.25 11 17.25C14.4518 17.25 17.25 14.4518 17.25 11C17.25 7.54822 14.4518 4.75 11 4.75Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
    <path d="M19.25 19.25L15.5 15.5" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" />
  </svg>
);

export const CloseIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = "text-gray-600",
  strokeWidth = 0.2,
  fillColor = "#000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="edit-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
    />
  </svg>
);
export const DeleteIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = "text-gray-600",
  strokeWidth = 0.2,
  fillColor = "#000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="edit-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M11.6449 2.04935C12.1134 1.58082 12.1134 0.819928 11.6449 0.351398C11.1763 -0.117133 10.4154 -0.117133 9.9469 0.351398L6 4.30205L2.04935 0.355146C1.58082 -0.113384 0.819928 -0.113384 0.351398 0.355146C-0.117133 0.823676 -0.117133 1.58457 0.351398 2.0531L4.30205 6L0.355146 9.95065C-0.113384 10.4192 -0.113384 11.1801 0.355146 11.6486C0.823676 12.1171 1.58457 12.1171 2.0531 11.6486L6 7.69795L9.95065 11.6449C10.4192 12.1134 11.1801 12.1134 11.6486 11.6449C12.1171 11.1763 12.1171 10.4154 11.6486 9.9469L7.69795 6L11.6449 2.04935Z"
    />
  </svg>
);
